













import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { formatTimeInterval } from "@/lib/time";
import { TIME_MEASURAND } from "@/const";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationAppointmentReminder",
  components: { NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup() {
    return { formatTimeInterval, TIME_MEASURAND };
  },
});
